import * as actions from './actions';
import reducer from './reducer';
import * as selectors from './selectors';
import NAMESPACE from './types';

export {
    actions,
    selectors,
};

export default {
    [NAMESPACE]: reducer,
};
